import Vue from 'vue'
import Router from 'vue-router'
import I18n from 'vue-i18n'

import { createApp } from './createApp'
import Api from './services/api'

import 'babel-polyfill'
import './components'
import './validation'
import './scripts'

const { app } = createApp({
  Vue,
  Router,
  I18n,
})

Vue.prototype.api = new Api('', 'application/json')

app.$mount('#app')

export { app }



// WEBPACK FOOTER //
// ./src/js/application.js